import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { ToasterService } from './toast.service';
import { GlobalDataService } from './global.data.service';
import { TenantRouterService } from './tenant.router.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
	const authService = inject(AuthService);
	const router = inject(Router);
	const token = authService.getToken();
	const globalDataService = inject(GlobalDataService);
	const toasterService = inject(ToasterService);
	const tenantRouterService = inject(TenantRouterService);

	const authReq = token
		? req.clone({
				headers: req.headers.set('Authorization', `Bearer ${token}`),
			})
		: req;

	return next(authReq).pipe(
		catchError((error: HttpErrorResponse) => {
			if (error.status === 403 || error.status === 401) {
				authService.logout();
				tenantRouterService.goLogin();
			}

			return throwError(() => error);
		})
	);
};
